<template>
  <div>
    <v-card>
      <v-card-title>Sub Setting 2</v-card-title>
      <v-card-text>
        <p>This is the demo page for Sub Setting 2.</p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'SubSetting2',
}
</script>
